<template>
    <div>
        <!-- 批量操作工具栏 -->
        <transition name="slide-up">
            <div v-if="selectedCount > 0"
                 class="batch-toolbar fixed left-0 right-0 bg-base-100/95 shadow-lg border-t border-base-300 z-50">
                <div class="batch-toolbar__inner container mx-auto px-3 sm:px-4 py-2.5 flex items-center justify-between gap-3">
                <!-- 左侧：选中数量 -->
                <div class="batch-toolbar__selection flex items-center gap-2 min-w-0">
                    <span class="batch-toolbar__count text-base-content font-medium truncate">
                        {{ $tt('batch.toolbar.selectedCount', { count: selectedCount }) }}
                    </span>
                    <button @click="$emit('clear-selection')"
                            class="btn btn-ghost btn-xs shrink-0">
                        {{ $tt('batch.toolbar.clearSelection') }}
                    </button>
                </div>

                <!-- 右侧：批量操作 -->
                <div class="flex gap-2">
                    <!-- 桌面端：下拉菜单 -->
                    <div class="dropdown dropdown-top dropdown-end hidden md:block">
                        <button tabindex="0" class="btn btn-primary btn-sm">
                            {{ $tt('批量操作') }}
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>
                        <ul tabindex="0" class="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-52 mb-2">
                            <li><a @click="handleAddToQueue">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                                </svg>
                                {{ $tt('添加到队列') }}
                            </a></li>
                            <li v-if="isInQueue"><a @click="handleRemoveFromQueue">
                                <svg t="1735707198915" class="h-4 w-4 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5275" width="200" height="200"><path d="M635.904 29.809778c6.712889 0 13.368889 1.592889 19.569778 4.778666l6.030222 3.754667 4.551111 3.982222 181.930667 182.784a41.699556 41.699556 0 0 1 10.353778 17.180445l1.592888 6.940444 0.398223 5.973334v153.031111a42.496 42.496 0 0 1-83.171556 12.344889l-1.422222-6.144-0.512-6.200889V349.980444h-158.947556a76.231111 76.231111 0 0 1-72.590222-53.304888l-1.934222-7.395556-1.194667-7.623111-0.455111-7.793778V114.915556H146.033778a24.917333 24.917333 0 0 0-21.048889 11.548444l-2.104889 4.323556-1.137778 4.039111-0.341333 4.778666v738.986667c0 10.581333 6.712889 19.740444 15.815111 23.096889l4.039111 1.080889 4.778667 0.398222h604.615111a24.746667 24.746667 0 0 0 23.096889-15.872l1.137778-3.982222 0.341333-4.778667v-67.128889a42.496 42.496 0 0 1 83.228444-12.401778l1.422223 6.200889 0.455111 6.144v100.807111c0 36.295111-25.6 67.128889-60.700445 74.524445l-7.623111 1.137778-7.793778 0.455111H112.412444a76.231111 76.231111 0 0 1-74.524444-60.700445l-1.137778-7.623111-0.455111-7.793778V105.984c0-36.408889 25.6-67.185778 60.700445-74.524444L104.618667 30.151111l7.793777-0.398222h523.491556z m-20.707556 638.179555a42.496 42.496 0 0 1 12.344889 83.171556l-6.144 1.479111-6.200889 0.455111H212.195556a42.496 42.496 0 0 1-12.344889-83.171555l6.200889-1.479112 6.144-0.455111h403.057777z m280.291556-174.421333l5.290667 4.494222 81.521777 81.521778a40.391111 40.391111 0 0 1 8.135112 11.946667l-0.398223-1.137778 1.991111 4.437333a35.157333 35.157333 0 0 1 1.706667 6.769778l0.455111 3.925333v6.769778l0.455111-2.275555 0.113778 0.568888a40.846222 40.846222 0 0 1-1.024 8.305778l-1.592889 5.404445-1.991111 4.664889-3.527111 5.802666-4.323556 5.063111-81.521777 81.578667a42.496 42.496 0 0 1-60.245334 0 42.609778 42.609778 0 0 1-4.494222-54.954667l4.494222-5.290666 8.817778-8.874667h-165.888a42.496 42.496 0 0 1-40.903111-30.663111l-1.251556-6.087111-0.398222-5.745778c0-21.617778 15.928889-39.367111 36.750222-42.154667l5.802667-0.398222h166.001778l-8.931556-8.988444a42.666667 42.666667 0 0 1-7.964444-49.152l3.470222-5.745778 4.551111-5.290667a42.609778 42.609778 0 0 1 54.897778-4.551111z m-280.291556-27.136a42.496 42.496 0 0 1 12.344889 83.228444l-6.144 1.422223-6.200889 0.455111H212.195556a42.496 42.496 0 0 1-12.344889-83.171556l6.200889-1.422222 6.144-0.512h403.057777zM413.696 264.931556a42.496 42.496 0 0 1 12.344889 83.171555l-6.200889 1.422222-6.144 0.512H212.138667a42.496 42.496 0 0 1-12.344889-83.228444l6.200889-1.422222 6.144-0.455111h201.557333z m211.512889-137.386667v112.753778c0 10.638222 6.712889 19.797333 15.872 23.153777l3.982222 1.080889 4.778667 0.398223 112.696889-0.056889-137.329778-137.329778z"></path></svg>
                                {{ $tt('移出队列') }}
                            </a></li>
                            <li><a @click="handleAddNextInQueue">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7" />
                                </svg>
                                {{ $tt('添加下一首') }}
                            </a></li>
                            <li><a @click="openPlaylistDialog">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                </svg>
                                {{ $tt('添加到播放列表') }}
                            </a></li>
                            <li v-if="$route.name !== 'favourites'"><a @click="handleAddToFavourite">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                </svg>
                                {{ $tt('添加到喜爱') }}
                            </a></li>
                            <li v-else><a @click="handleAddToFavourite">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                </svg>
                                {{ $tt('移出喜爱') }}
                            </a></li>
                            <li v-if="isInPlaylist"><a @click="handleRemoveFromPlaylist">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                {{ $tt('移出播放列表') }}
                            </a></li>
                            <li v-if="isSuperUser" class="border-t border-base-300 mt-1">
                                <a @click="confirmDelete" class="text-error">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                    </svg>
                                    {{ $tt('删除音乐') }}
                                </a>
                            </li>
                        </ul>
                    </div>

                    <!-- 移动端：核心操作按钮 -->
                    <div class="md:hidden batch-toolbar__mobile-actions flex gap-2 shrink-0 overflow-x-auto scrollbar-hide">
                        <button @click="handleAddToQueue" class="btn btn-sm btn-primary whitespace-nowrap shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" /></svg>
                            {{ $tt('加入队列') }}
                        </button>
                        <button v-if="isInQueue" @click="handleRemoveFromQueue" class="btn btn-sm btn-ghost whitespace-nowrap shrink-0">
                            {{ $tt('移出队列') }}
                        </button>
                        <button @click="handleAddNextInQueue" class="btn btn-sm btn-ghost whitespace-nowrap shrink-0">
                            {{ $tt('添加下一首') }}
                        </button>
                        <button @click="openPlaylistDialog" class="btn btn-sm btn-ghost whitespace-nowrap shrink-0">
                            {{ $tt('添加到播放列表') }}
                        </button>
                        <button @click="handleAddToFavourite" class="btn btn-sm btn-ghost whitespace-nowrap shrink-0">
                            {{ $route.name === 'favourites' ? $tt('移出喜爱') : $tt('添加到喜爱') }}
                        </button>
                        <button v-if="isInPlaylist" @click="handleRemoveFromPlaylist" class="btn btn-sm btn-ghost whitespace-nowrap shrink-0">
                            {{ $tt('移出播放列表') }}
                        </button>
                        <button v-if="isSuperUser" @click="confirmDelete" class="btn btn-sm btn-ghost btn-error whitespace-nowrap shrink-0">
                            {{ $tt('删除音乐') }}
                        </button>
                        <button @click="showMobileActions = true" class="btn btn-sm btn-ghost whitespace-nowrap shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 12h.01M12 12h.01M18 12h.01" /></svg>
                            {{ $tt('更多') }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- 进度提示 -->
            <div v-if="showProgress" class="px-4 pb-3">
                <progress class="progress progress-primary w-full" :value="progress" max="100"></progress>
                    <p class="text-sm text-center mt-1 text-base-content/70">{{ progressText }}</p>
                </div>
            </div>
        </transition>

        <!-- 播放列表选择对话框 -->
        <dialog :class="['modal', {'modal-open': showPlaylistDialog}]" @click.self="showPlaylistDialog = false">
        <div class="modal-box">
            <h3 class="font-bold text-lg mb-4">{{ $tt('添加到播放列表') }}</h3>
            <div class="form-control w-full">
                <label class="label">
                    <span class="label-text">{{ $tt('选择播放列表') }}</span>
                </label>
                <select v-model="selectPlaylistId" class="select select-bordered w-full">
                    <option value="">{{ $tt('请选择') }}</option>
                    <option v-for="playlist in playLists" :key="playlist.id" :value="playlist.id">
                        {{ playlist.name }}
                    </option>
                </select>
            </div>
            <div class="modal-action">
                <button @click="showPlaylistDialog = false" class="btn btn-ghost">{{ $tt('取消') }}</button>
                <button @click="handleAddToPlaylist" class="btn btn-primary" :disabled="!selectPlaylistId">{{ $tt('确认') }}</button>
            </div>
        </div>
        <form method="dialog" class="modal-backdrop" @click="showPlaylistDialog = false">
            <button>close</button>
        </form>
    </dialog>

    <!-- 移动端操作面板 -->
    <dialog :class="['modal modal-bottom sm:modal-middle', {'modal-open': showMobileActions}]" @click.self="showMobileActions = false">
        <div class="modal-box batch-actions-sheet">
            <div class="flex items-center justify-between mb-3">
                <div>
                    <h3 class="font-bold text-lg">{{ $tt('批量操作') }}</h3>
                    <p class="text-xs text-base-content/60 mt-0.5">{{ $tt('batch.toolbar.selectedCount', { count: selectedCount }) }}</p>
                </div>
                <button class="btn btn-sm btn-circle btn-ghost" @click="showMobileActions = false" :aria-label="$tt('关闭')">×</button>
            </div>
            <ul class="batch-actions-grid menu bg-base-200/70 rounded-box p-2">
                <li><a @click="handleAddNextInQueue(); showMobileActions = false">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7" />
                    </svg>
                    {{ $tt('添加下一首') }}
                </a></li>
                <li v-if="isInQueue"><a @click="handleRemoveFromQueue(); showMobileActions = false">
                    <svg t="1735707198915" class="w-5 h-5 fill-current" viewBox="0 0 1024 1024"><path d="M635.904 29.809778c6.712889 0 13.368889 1.592889 19.569778 4.778666l6.030222 3.754667 4.551111 3.982222 181.930667 182.784a41.699556 41.699556 0 0 1 10.353778 17.180445l1.592888 6.940444.398223 5.973334v153.031111a42.496 42.496 0 0 1-83.171556 12.344889l-1.422222-6.144-.512-6.200889V349.980444h-158.947556a76.231111 76.231111 0 0 1-72.590222-53.304888l-1.934222-7.395556-1.194667-7.623111-.455111-7.793778V114.915556H146.033778a24.917333 24.917333 0 0 0-21.048889 11.548444l-2.104889 4.323556-1.137778 4.039111-.341333 4.778666v738.986667c0 10.581333 6.712889 19.740444 15.815111 23.096889l4.039111 1.080889 4.778667.398222h604.615111a24.746667 24.746667 0 0 0 23.096889-15.872l1.137778-3.982222.341333-4.778667v-67.128889a42.496 42.496 0 0 1 83.228444-12.401778l1.422223 6.200889.455111 6.144v100.807111c0 36.295111-25.6 67.128889-60.700445 74.524445l-7.623111 1.137778-7.793778.455111H112.412444a76.231111 76.231111 0 0 1-74.524444-60.700445l-1.137778-7.623111-.455111-7.793778V105.984c0-36.408889 25.6-67.185778 60.700445-74.524444L104.618667 30.151111l7.793777-.398222h523.491556z"/></svg>
                    {{ $tt('移出队列') }}
                </a></li>
                <li><a @click="showMobileActions = false; openPlaylistDialog()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                    </svg>
                    {{ $tt('添加到播放列表') }}
                </a></li>
                <li><a @click="handleAddToFavourite(); showMobileActions = false">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                    </svg>
                    {{ $tt('添加到喜爱') }}
                </a></li>
                <li v-if="isInPlaylist"><a @click="handleRemoveFromPlaylist(); showMobileActions = false">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    {{ $tt('移出播放列表') }}
                </a></li>
                <li v-if="isSuperUser" class="border-t border-base-300 mt-2">
                    <a @click="confirmDelete(); showMobileActions = false" class="text-error">
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                        {{ $tt('删除音乐') }}
                    </a>
                </li>
            </ul>
        </div>
        <form method="dialog" class="modal-backdrop" @click="showMobileActions = false">
            <button>close</button>
        </form>
    </dialog>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'TrackBatchToolbar',
    props: {
        selectedItems: {
            type: Array,
            required: true
        },
        isInPlaylist: {
            type: Boolean,
            default: false
        },
        playlistId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            showProgress: false,
            progress: 0,
            progressText: '',
            showPlaylistDialog: false,
            showMobileActions: false,
            playLists: [],
            selectPlaylistId: ''
        }
    },
    computed: {
        ...mapGetters({
            isSuperUser: 'getIsSuperuser'
        }),
        selectedCount() {
            return this.selectedItems.length
        },
        isInQueue() {
            const queue = this.$store.state.common.queue || []
            return queue.some(track => this.selectedItems.some(item => item.id === track.id))
        }
    },
    methods: {
        // 打开播放列表对话框并获取播放列表
        async openPlaylistDialog() {
            // 先获取播放列表数据，再打开对话框
            if (this.playLists.length === 0) {
                await this.fetchPlayLists()
            }
            this.showPlaylistDialog = true
        },
        // 获取播放列表
        async fetchPlayLists() {
            try {
                const res = await this.$api.subsonic.getPlaylists()
                // 接口直接返回播放列表数组
                this.playLists = Array.isArray(res) ? res : []
                console.log('最终 playLists:', this.playLists)
            } catch (error) {
                console.error('获取播放列表失败:', error)
            }
        },
        // 添加到队列
        handleAddToQueue() {
            this.$store.commit('addToQueue', this.selectedItems)
            this.$myMsg.notify({
                title: this.$tt('batch.toolbar.addedToQueue', { count: this.selectedItems.length }),
                type: 'success',
                time: 2000
            })
        },
        handleRemoveFromQueue() {
            const queue = this.$store.state.common.queue || []
            const selectedIds = this.selectedItems.map(item => item.id)

            // 找出所有需要移除的歌曲在队列中的索引（倒序以避免索引变化影响）
            const indicesToRemove = []
            queue.forEach((track, index) => {
                if (selectedIds.includes(track.id)) {
                    indicesToRemove.push(index)
                }
            })

            // 倒序移除，避免索引变化
            indicesToRemove.reverse().forEach(index => {
                this.$store.commit('removeFromQueue', index)
            })

            if (indicesToRemove.length > 0) {
                this.$myMsg.notify({
                    title: this.$tt('batch.toolbar.removedFromQueue', { count: indicesToRemove.length }),
                    type: 'success',
                    time: 2000
                })
            }
        },
        // 添加下一首
        handleAddNextInQueue() {
            this.$store.commit('setNextInQueue', this.selectedItems)
            this.$myMsg.notify({
                title: this.$tt('batch.toolbar.addedToNext', { count: this.selectedItems.length }),
                type: 'success',
                time: 2000
            })
        },
        // 添加到播放列表
        async handleAddToPlaylist() {
            if (!this.selectPlaylistId) return

            try {
                const trackIds = this.selectedItems.map(item => item.id)
                await this.$api.subsonic.addToPlaylist(this.selectPlaylistId, trackIds)

                this.$myMsg.notify({
                    title: this.$tt('batch.toolbar.addedToPlaylist', { count: trackIds.length }),
                    type: 'success',
                    time: 2000
                })

                this.showPlaylistDialog = false
                this.selectPlaylistId = ''
            } catch (error) {
                this.$myMsg.notify({
                    title: this.$tt('添加失败'),
                    message: error.message,
                    type: 'error',
                    time: 2000
                })
            }
        },
        // 添加到喜爱
        async handleAddToFavourite() {
            this.showProgress = true
            this.progressText = this.$tt('batch.toolbar.addingToFavorite')
            this.progress = 0

            const results = await Promise.allSettled(
                this.selectedItems.map(item =>
                    this.$api.subsonic.addFavourite(item.id, 'track')
                )
            )

            const succeeded = results.filter(r => r.status === 'fulfilled').length
            const failed = results.filter(r => r.status === 'rejected').length

            this.showProgress = false

            this.$myMsg.notify({
                title: failed > 0
                    ? this.$tt('batch.toolbar.successFailed', { succeeded, failed })
                    : this.$tt('batch.toolbar.successOnly', { succeeded }),
                type: failed > 0 ? 'warning' : 'success',
                time: 2000
            })
        },
        // 移出播放列表
        async handleRemoveFromPlaylist() {
            if (!this.playlistId) return

            // 按索引降序排列，避免删除导致索引错乱
            const sortedItems = [...this.selectedItems].sort((a, b) => b.index - a.index)

            this.showProgress = true
            this.progress = 0
            this.progressText = this.$tt('batch.toolbar.removingFromPlaylist')

            for (let i = 0; i < sortedItems.length; i++) {
                try {
                    await this.$api.subsonic.removeFromPlaylist(
                        this.playlistId,
                        sortedItems[i].index
                    )
                } catch (error) {
                    console.error('移出播放列表失败:', error)
                }
                this.progress = Math.round(((i + 1) / sortedItems.length) * 100)
            }

            this.showProgress = false

            this.$myMsg.notify({
                title: this.$tt('batch.toolbar.removedFromPlaylist', { count: sortedItems.length }),
                type: 'success',
                time: 2000
            })

            this.$emit('refresh') // 刷新列表
            this.$emit('clear-selection')
        },
        // 确认删除
        confirmDelete() {
            if (!confirm(this.$tt('batch.toolbar.confirmDelete', { count: this.selectedItems.length }))) {
                return
            }
            this.handleBatchDelete()
        },
        // 批量删除
        async handleBatchDelete() {
            this.showProgress = true
            this.progress = 0
            this.progressText = this.$tt('batch.toolbar.deleting')

            let succeeded = 0
            let failed = 0

            for (let i = 0; i < this.selectedItems.length; i++) {
                try {
                    await this.$api.Task.deleteTrack({
                        track_id: this.selectedItems[i].id,
                        mode: 'delete_file'
                    })
                    succeeded++
                } catch (error) {
                    failed++
                    console.error('删除失败:', error)
                }

                this.progress = Math.round(((i + 1) / this.selectedItems.length) * 100)
                this.progressText = this.$tt('batch.toolbar.deletingProgress', { current: i + 1, total: this.selectedItems.length })
            }

            this.showProgress = false

            this.$myMsg.notify({
                title: failed > 0
                    ? this.$tt('batch.toolbar.deleteDoneWithFail', { succeeded, failed })
                    : this.$tt('batch.toolbar.deleteDone', { succeeded }),
                type: failed > 0 ? 'warning' : 'success',
                time: 2000
            })

            this.$emit('refresh')
            this.$emit('clear-selection')
        }
    }
}
</script>

<style scoped>
/* 批量工具栏动画 */
.slide-up-enter-active,
.slide-up-leave-active {
    transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
    transform: translateY(100%);
    opacity: 0;
}

.batch-toolbar {
    bottom: calc(4.5rem + env(safe-area-inset-bottom, 0px));
    backdrop-filter: blur(16px);
}

@media (min-width: 768px) {
    .batch-toolbar { bottom: 0; }
}

.batch-actions-sheet {
    width: 100%;
    max-width: 32rem;
    padding: 1rem 1rem calc(1rem + env(safe-area-inset-bottom, 0px));
    border-radius: 1.25rem 1.25rem 0 0;
}

.batch-actions-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.35rem;
}

.batch-actions-grid li a {
    min-height: 3.25rem;
    gap: 0.65rem;
    justify-content: flex-start;
    border-radius: 0.75rem;
    padding: 0.75rem;
    font-size: 0.9rem;
}

@media (max-width: 380px) {
    .batch-toolbar__inner { padding-left: 0.65rem; padding-right: 0.65rem; }
    .batch-toolbar__count { max-width: 5.5rem; font-size: 0.8rem; }
    .batch-toolbar__mobile-actions .btn { padding-left: 0.55rem; padding-right: 0.55rem; }
}

@media (max-width: 767px) {
    .batch-toolbar__inner {
        display: block;
    }

    .batch-toolbar__selection {
        width: 100%;
        justify-content: space-between;
        margin-bottom: 0.45rem;
    }

    .batch-toolbar__mobile-actions {
        width: 100%;
        padding-bottom: 0.1rem;
        -webkit-overflow-scrolling: touch;
    }

    .batch-toolbar__mobile-actions .btn {
        min-height: 2.5rem;
    }
}
</style>
